module.exports = __webpack_public_path__ + "img/adoisjota_brand_white.8aa9ab88.png";